import { render } from "./AgencyPreference.vue?vue&type=template&id=b7794a8a"
import script from "./AgencyPreference.vue?vue&type=script&lang=js"
export * from "./AgencyPreference.vue?vue&type=script&lang=js"
script.render = render

export default script